import React from 'react';
import { selectColorFromPalette } from 'named-color-maps/selectColorFromPalette';
import { makeCachedMap } from 'named-color-maps/makeCachedMap';
const NamedColorsContextDefault = {}; // @ts-ignore

const NamedColorsContext = /*#__PURE__*/React.createContext(NamedColorsContextDefault);
export const useNamedColors = id => {
  const context = React.useContext(NamedColorsContext);
  const cachedMap = context[id];

  if (!cachedMap) {
    console.log('color map id not found: ' + cachedMap);
  }

  const getNamedColor = React.useCallback((color, defaultColor) => {
    if (color && cachedMap) {
      if (color.indexOf('#') === 0 && cachedMap.entries[cachedMap.colorMap[color]]) {
        return cachedMap.entries[cachedMap.colorMap[color]];
      }

      if (cachedMap.entries[cachedMap.nameMap[color]]) {
        return cachedMap.entries[cachedMap.nameMap[color]];
      }
    }

    return defaultColor ? getNamedColor(defaultColor) : undefined;
  }, [cachedMap]);
  const getColorsInHex = React.useCallback(() => {
    return (cachedMap === null || cachedMap === void 0 ? void 0 : cachedMap.colors) || [];
  }, [cachedMap]);
  return {
    colorMaps: context,
    getNamedColor,
    getColorsInHex
  };
};
export const NamedColorsProvider = ({
  children,
  shadedColors,
  colorMaps,
  palette
}) => {
  const selectColor = React.useCallback((colorOrName, defaultColor) => {
    return selectColorFromPalette(palette, shadedColors, colorOrName, defaultColor);
  }, [palette, shadedColors]);
  const makeCachedMapFn = React.useCallback((id, colorList) => {
    return makeCachedMap(selectColor, id, colorList);
  }, [selectColor]);
  const cachedMaps = React.useMemo(() => {
    const map = {};
    Object.keys(colorMaps).forEach(mapId => {
      map[mapId] = makeCachedMapFn(mapId, colorMaps[mapId]);
    });
    return map;
  }, [colorMaps, makeCachedMapFn]);
  return /*#__PURE__*/React.createElement(NamedColorsContext.Provider, {
    value: cachedMaps
  }, children);
};